import React from 'react';

import Parallax from '../common/Parallax.jsx';

function ArtistImageParallaxComponent(props) {
    let artist = props.data || {};
    if (artist.artist) {
        artist = artist.artist;
    }
    let image = artist.cover;
    if (props.blockConfig && props.blockConfig.block) {
        switch (props.blockConfig.block.source) {
            case 'profile':
                image = artist.profile;
                break;
        }
    }
    return <Parallax.ImageContainer.Component {...props} data={[{ artist,  image }]} slideComponent={ArtistImageParallaxCell} />
}

function ArtistImageParallaxCell(props) {
    let data = props.data;
    if (data && data.artist) {
        data = data.artist;
    }
    let blockConfig = props.blockConfig;
    if (!blockConfig && props.parentBlock) {
        blockConfig = props.parentBlock.config;
    }
    let image = data.cover;
    if (blockConfig && blockConfig.block) {
        switch (blockConfig.block.source) {
            case 'profile':
                image = data.profile;
                break;
        }
    }
    return <Parallax.ImageContainer.Cell {...props} image={image} />
}

export default { Cell: ArtistImageParallaxCell, Component: ArtistImageParallaxComponent };